import type {
  AlphaGroupDetail,
  AlphaGroupEnrollResponse,
  AlphaGroupListResponse,
} from "@smartwiz/shared-types";
import axios from "axios";
import { backend_url } from "@/constants";
import { AXIOS_CONFIG } from "@/utils/api";

const ALPHA_BASE = "api/feature-flag/alpha";

export const getAlphaGroup = async (
  slug: string
): Promise<AlphaGroupDetail> => {
  const response = await axios.get(
    `${backend_url}/${ALPHA_BASE}/${slug}/`,
    AXIOS_CONFIG
  );
  return response.data.content;
};

export const enrollInAlpha = async (
  slug: string
): Promise<AlphaGroupEnrollResponse> => {
  const response = await axios.post(
    `${backend_url}/${ALPHA_BASE}/${slug}/enroll/`,
    {},
    AXIOS_CONFIG
  );
  return response.data.content;
};

export const unenrollFromAlpha = async (
  slug: string
): Promise<AlphaGroupEnrollResponse> => {
  const response = await axios.post(
    `${backend_url}/${ALPHA_BASE}/${slug}/unenroll/`,
    {},
    AXIOS_CONFIG
  );
  return response.data.content;
};

export const listAlphaGroups = async (): Promise<AlphaGroupListResponse> => {
  const response = await axios.get(
    `${backend_url}/${ALPHA_BASE}/`,
    AXIOS_CONFIG
  );
  return response.data.content;
};
